import CommonChip from '@app/src/components/CommonChip'
import { CheckRounded } from '@mui/icons-material'
import { useTheme } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface AcceptanceValueChipProps {
  label: string
  tooltip: string
  accepted: boolean
  delayMs: number
}

const AcceptanceValueChip: React.FC<AcceptanceValueChipProps> = ({ label, tooltip, accepted, delayMs }) => {
  const { formatMessage } = useIntl()
  const { palette, transitions } = useTheme()
  const transition = {
    transition: transitions.create(['background-color', 'border-color', 'color'], {
      duration: 350,
      easing: transitions.easing.easeInOut,
    }),
    transitionDelay: `${delayMs}ms`,
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
  }

  return (
    <CommonChip
      label={label}
      tooltip={tooltip}
      tabIndex={0}
      variant="outlined"
      aria-label={`${label}: ${formatMessage({
        id: accepted ? 'aiScreening.acceptance.accepted' : 'aiScreening.acceptance.notAccepted',
      })}`}
      icon={accepted ? <CheckRounded aria-hidden /> : undefined}
      sx={{
        ...transition,
        borderColor: accepted ? palette.success.dark : palette.divider,
        bgcolor: accepted ? palette.success.dark : 'transparent',
        color: accepted ? palette.success.contrastText : palette.text.secondary,
        '& .MuiChip-icon': { color: 'inherit', ml: 1, mr: 0 },
        '& .MuiChip-label': { pl: accepted ? 0.75 : 1.5, pr: 1.5 },
      }}
    />
  )
}

export default AcceptanceValueChip
